import React, { useEffect, useState } from 'react'
import { getDefaultName } from '../utils'
import { loadCity } from '../utils/Network'

export default function CityName({id}) {

    const [city , setCity] = useState(null)
    
    useEffect(() => {
        if(id){
            loadCity(id).then(city =>{
                setCity(city)
            })
        }
    }, [id])

    return (
        <>
            {city && getDefaultName(city.names)}
        </>
    )
}
